import { VideoForm } from "../components"
import { BASE_URL } from "../constants"
import axios from 'axios';
import { DocumentTitle } from "../utils";

const NewVideo = () => {
  DocumentTitle(`New Video`);

  const addNewVideo = async (formData) => {
    try {
      const res = await axios.post(`${BASE_URL}/video/newVideo.php`, formData);
      const resObject = await res.data;

      return resObject;
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <VideoForm handleFormAction={addNewVideo} />
  )
}

export default NewVideo